<template>
  <AsideGabarit :title="$t('filters.servicesAndPublicTransport')" :action="action">
    <ToggleFilter :caption="$t('transportMode.public')" :override-active="publicTransportLinesShown" :action="togglePublicTransportLines">
      <template #icon>
        <i class="icon-bus" />
      </template>
    </ToggleFilter>

    <div class="container">
      <ToggleFilter
        v-for="pin in pinTypes"
        :key="pin.id"
        :caption="$t(`pointOfInterestCategories.${pin.name}`)"
        :override-active="poiVisibilityStatus(pin.key)"
        :action="() => togglePoiVisibility(pin.key)"
      >
        <template #icon>
          <i :class="pin.icon" />
        </template>
      </ToggleFilter>
    </div>

    <ToggleFilter :caption="$t('airQualityIndexOverlay.label')" :override-active="airQualityIndexOverlayShown" :action="toggleAirQualityIndexOverlay">
      <template #icon>
        <i class="icon-environment" />
      </template>

      <template #body>
        <div class="air-quality-captions">
          <div>{{ $t('airQualityIndexOverlay.caption1') }}</div>
          <div>{{ $t('airQualityIndexOverlay.caption2') }}</div>

          <div class="air-quality-ranges-container">
            <span>0-50</span>
            <span>{{ $t('airQualityIndexOverlay.level1') }}</span>

            <span>51-100</span>
            <span>{{ $t('airQualityIndexOverlay.level2') }}</span>

            <span>101-150</span>
            <span>{{ $t('airQualityIndexOverlay.level3') }}</span>

            <span>151-200</span>
            <span>{{ $t('airQualityIndexOverlay.level4') }}</span>

            <span>201-300</span>
            <span>{{ $t('airQualityIndexOverlay.level5') }}</span>

            <span>300+</span>
            <span>{{ $t('airQualityIndexOverlay.level6') }}</span>

            <span>—</span>
            <span>{{ $t('airQualityIndexOverlay.noData') }}</span>
          </div>

          <div>{{ $t('airQualityIndexOverlay.caption3') }}</div>
        </div>
      </template>
    </ToggleFilter>
  </AsideGabarit>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import AsideGabarit from './AsideGabarit';
import ToggleFilter from './ToggleFilter';

export default {
  components: {
    AsideGabarit,
    ToggleFilter,
  },

  props: ['action'],

  data() {
    return {
      pinTypes: [
        { id: 1, name: 'restaurant', key: 'restaurant', icon: 'icon-cutlery' },
        { id: 2, name: 'supermarket', key: 'supermarket', icon: 'icon-cart' },
        { id: 3, name: 'school', key: 'school', icon: 'icon-baby' },
        { id: 4, name: 'gym', key: 'gym', icon: 'icon-impairs' },
      ],
    };
  },

  computed: {
    ...mapGetters(['poiVisibilityStatus', 'publicTransportLinesShown', 'airQualityIndexOverlayShown']),
  },

  methods: {
    ...mapActions(['togglePoiVisibility', 'togglePublicTransportLines', 'toggleAirQualityIndexOverlay']),
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';

.air-quality-captions {
  color: colors.$nude-concrete-color;
  font-size: 11px;
  font-style: italic;
  margin: 0;

  .air-quality-ranges-container {
    display: grid;
    grid-template-columns: max-content 1fr;
    font-style: normal;
    margin-block: 8px;
    row-gap: 2px;
    column-gap: 1px;

    > span {
      padding: 2px 4px;
      color: white;
    }

    > span:nth-child(1) {
      border-top-left-radius: 4px;
    }
    > span:nth-child(2) {
      border-top-right-radius: 4px;
    }
    > span:nth-last-child(2) {
      border-bottom-left-radius: 4px;
    }
    > span:nth-last-child(1) {
      border-bottom-right-radius: 4px;
    }

    > span:nth-child(1),
    > span:nth-child(2) {
      background-color: #009966;
    }
    > span:nth-child(3),
    > span:nth-child(4) {
      background-color: #ffde33;
      color: black;
    }
    > span:nth-child(5),
    > span:nth-child(6) {
      background-color: #ff9933;
      color: black;
    }
    > span:nth-child(7),
    > span:nth-child(8) {
      background-color: #cc0033;
    }
    > span:nth-child(9),
    > span:nth-child(10) {
      background-color: #660099;
    }
    > span:nth-child(11),
    > span:nth-child(12) {
      background-color: #7e0023;
    }
    > span:nth-child(13),
    > span:nth-child(14) {
      background-color: #cccccc;
      color: black;
    }
  }
}
</style>
